import type { RouteObject } from 'react-router';
import { Navigate } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

export const adminRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="mtm" />,
  },
  {
    path: 'momentm',
    lazy: () =>
      import('./tabs/MomentmSettingsTab').then((m) => ({
        Component: m.MomentmSettingsTab,
      })),
  },
  {
    path: 'mtm',
    lazy: () =>
      import('./tabs/MTMSettingsTab').then((m) => ({
        Component: m.MTMSettingsTab,
      })),
  },
  {
    path: 'internal',
    lazy: () =>
      import('./tabs/InternalTab').then((m) => ({ Component: m.InternalTab })),
  },
  {
    path: 'kinetik',
    lazy: () =>
      import('./tabs/KinetikSettingsTab').then((m) => ({
        Component: m.KinetikSettingsTab,
      })),
  },
  {
    path: 'alivi',
    lazy: () =>
      import('./tabs/AliviSettingsTab').then((m) => ({
        Component: m.AliviSettingsTab,
      })),
  },
  {
    path: 'clearview',
    lazy: () =>
      import('./tabs/ClearviewSettingsTab').then((m) => ({
        Component: m.ClearviewSettingsTab,
      })),
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute routePath="/admin" linkText="Go back to admin" />
    ),
  },
];
